import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old person page URL → `/people/$contactId` (stored links in notifications, jobs and emails keep working). */
export const Route = createFileRoute("/_app/contacts/$contactId")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/people/$contactId", params: { contactId: params.contactId }, replace: true });
  },
});
